export default function MutedDishComponent({ isMuted, setIsMuted }: { isMuted: boolean, setIsMuted: (muted: boolean) => void }) {

    return <button onClick={() => setIsMuted(!isMuted)}>{isMuted ? <i className='las la-volume-off' /> : <i className='las la-volume-up' />}</button>

}